import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import AppRedirect from '../components/shared/AppRedirect';

import CreditPolicyListContainer from '../components/asegurado/credit/CreditPolicyListContainer';
import SolicitudesProrrogaListContainer from '../components/asegurado/credit/SolicitudesProrrogaListContainer';
import GarantiaPolicyListContainer from '../components/asegurado/garantia/GarantiaPolicyListContainer';
import CreditPolicyDetail from '../components/asegurado/credit/CreditPolicyDetail';
import GarantiaPolicyDetail from '../components/asegurado/garantia/GarantiaPolicyDetail';
import CorredorGarantiaPolicyListContainer from '../components/corredor/garantia/CorredorGarantiaPolicyListContainer';
import CorredorGarantiaDetail from '../components/corredor/garantia/CorredorGarantiaDetail';
import CorredorCreditoPolicyListContainer from '../components/corredor/credito/CorredorCreditoPolicyListContainer';
import getUserHome from '../helpers/routeHelper';
import CorredorCreditoPolicyDetail from '../components/corredor/credito/CorredorCreditoPolicyDetail';
import ProduccionMensualGarantiaContainer from '../components/corredor/garantia/ProduccionMensualGarantiaContainer';
import GarantiaLineaDetail from '../components/asegurado/garantia/GarantiaLineaDetail';
import CorredorLineaGarantiaListContainer from '../components/corredor/garantia/CorredorLineaGarantiaListContainer';
import CorredorLineaGarantiaClienteDetailContainer from '../components/corredor/garantia/CorredorLineaGarantiaClienteDetailContainer';
import CreditLineContainer from '../components/asegurado/credit/line/CreditLineContainer';
import LibrosVentaContainer from '../components/asegurado/credit/LibrosVentaContainer';
import CreditPolicyDeudorLineasContainer from '../components/asegurado/credit/line/CreditPolicyDeudorLineasContainer';
import CreditLineDetailContainer from '../components/asegurado/credit/line/CreditLineDetailContainer';
import CorredorCreditoLiquidacionListContainer from '../components/corredor/credito/CorredorCreditoLiquidacionListContainer';
import CorredorLiquidacionCreditoDetalleContainer from '../components/corredor/credito/CorredorLiquidacionCreditoDetalleContainer';
import CorredorGarantiaLiquidacionListContainer from '../components/corredor/garantia/CorredorGarantiaLiquidacionListContainer';
import CorredorLiquidacionGarantiaDetalleContainer from '../components/corredor/garantia/CorredorLiquidacionGarantiaDetalleContainer';
import FacturacionCreditoContainer from '../components/asegurado/credit/facturacion/FacturacionCreditoContainer';
import SolicitudesProrrogaContainer from '../components/asegurado/credit/prorroga/SolicitudesProrrogaContainer';
import SolicitudProrroga from '../components/asegurado/credit/prorroga/SolicitudProrroga';
import SolicitudProrrogaRedirectContainer from '../components/asegurado/credit/prorroga/SolicitudProrrogaRedirectContainer';
import ConsolidadoCreditoContainer from '../components/asegurado/credit/consolidado/ConsolidadoCreditoContainer';
import ResumenContainer from '../components/orsan/ResumenContainer';
import OperacionesLibrosVentaContainer from '../components/operaciones/OperacionesLibrosVentaContainer';
import OperacionesLiquidacionCreditoContainer from '../components/operaciones/OperacionesLiquidacionCreditoContainer';
import isUserHasProfile from '../helpers/profileValidator';
import { externalUserHasRole } from '../helpers/helpers';
import {
  LINEA_CREDITO_WRITE,
} from '../helpers/profilePermission';
import { PROFILES, ROLES_CORREDOR } from 'CONST';

const LoggedInRoutes = ({ user }) => {
  const userHomeComponent = getUserHome(user).component;
  const hasAccion = (slug) => {
    if (!user.acciones_permitidas?.acciones) return false;
    
    return user.acciones_permitidas.acciones.some(
      accion => 
        accion.applies && 
        accion.is_active && 
        accion.accion.slug === slug
    );
  };
  
  const canAccessLibrosVenta = () => {
    const isIntermediarioCredito = user.roles && user.roles.includes('intermediariocredito');
    
    if (isIntermediarioCredito) {
      return hasAccion('ver-modulo-libro-venta');
    }
    
    return true;
  };
  
  return !user.has_access ? (
    <AppRedirect />
  ) : (
    <Switch>
      <Route exact path="/" component={userHomeComponent} />
      <Route exact path="/asegurado/polizas-credito" component={CreditPolicyListContainer} />
      <Route path="/asegurado/polizas-credito/:id" component={CreditPolicyDetail} />
      <Route exact path="/asegurado/polizas-garantia" component={GarantiaPolicyListContainer} />
      <Route path="/asegurado/polizas-garantia/:id" component={GarantiaPolicyDetail} />
      <Route path="/asegurado/linea-garantia/" component={GarantiaLineaDetail} />
      {isUserHasProfile(LINEA_CREDITO_WRITE) && (
        <Route path="/asegurado/linea-credito/:policyId" component={CreditLineContainer} />
      )}
      {canAccessLibrosVenta() && (
        <Route path="/asegurado/libros-venta/:policyId?" component={LibrosVentaContainer} />
      )}
      {(user.is_orsan) && (
        <Route path="/prorroga/solicitudes-prorroga/:policyId?" component={SolicitudesProrrogaContainer}
        />
      )}
      {/* Se repite la condicion a proposito porque unirlos y dejar como padre un fragment (<></>) no funciona */}
      {(isUserHasProfile([PROFILES.externoAdministradorAseguradoCredito]) || externalUserHasRole(user, ROLES_CORREDOR) || user.is_orsan) && (
        <Route exact path="/prorroga/solicitud-prorroga/redirect" component={SolicitudProrrogaRedirectContainer} />
      )}
      {(isUserHasProfile([PROFILES.externoAdministradorAseguradoCredito]) || externalUserHasRole(user, ROLES_CORREDOR) || user.is_orsan) && (
        <Route path="/prorroga/solicitud-prorroga/:policyId?" component={SolicitudProrroga} />
      )}
      <Route path="/asegurado/lineas-credito/detalle/:id" component={CreditLineDetailContainer} />
      <Route path="/asegurado/lineas-credito/" component={CreditPolicyDeudorLineasContainer} />

      <Route path="/asegurado/facturacion/:policyId" component={FacturacionCreditoContainer} />
      <Route path="/asegurado/consolidado-credito/" component={ConsolidadoCreditoContainer} />

      {(externalUserHasRole(user, ROLES_CORREDOR) || user.is_orsan) && (
        <Route
          exact
          path="/corredor/polizas-credito"
          component={CorredorCreditoPolicyListContainer}
        />
      )}
      {(externalUserHasRole(user, ROLES_CORREDOR) || user.is_orsan) && canAccessLibrosVenta() && (
        <Route path="/corredor/libros-venta/:policyId?" component={LibrosVentaContainer} />
      )}
      
      {(externalUserHasRole(user, ROLES_CORREDOR) || user.is_orsan) && (
        <Route path="/corredor/polizas-credito/:id" component={CreditPolicyDetail}  />
      )}

      {!externalUserHasRole(user, ROLES_CORREDOR) && (
        <Route
          exact
          path="/corredor/polizas-garantia"
          component={CorredorGarantiaPolicyListContainer}
        />
      )}
      {!externalUserHasRole(user, ROLES_CORREDOR) && (
        <Route exact path="/corredor/polizas-garantia/:id" component={CorredorGarantiaDetail} />
      )}
      {!externalUserHasRole(user, ROLES_CORREDOR) && (
        <Route
          exact
          path="/corredor/produccion-mensual"
          component={ProduccionMensualGarantiaContainer}
        />
      )}
      {!externalUserHasRole(user, ROLES_CORREDOR) && (
        <Route
          exact
          path="/corredor/lineas-garantia/"
          component={CorredorLineaGarantiaListContainer}
        />
      )}
      {!externalUserHasRole(user, ROLES_CORREDOR) && (
        <Route
          exact
          path="/corredor/lineas-garantia/:id"
          component={CorredorLineaGarantiaClienteDetailContainer}
        />
      )}
      {(externalUserHasRole(user, ROLES_CORREDOR) || user.is_orsan) && (
        <Route
          exact
          path="/corredor/liquidacion-credito/"
          component={CorredorCreditoLiquidacionListContainer}
        />
      )}
      {(externalUserHasRole(user, ROLES_CORREDOR) || user.is_orsan) && (
        <Route
          exact
          path="/corredor/liquidacion-credito/:liquidacionId"
          component={CorredorLiquidacionCreditoDetalleContainer}
        />
      )}
      {!externalUserHasRole(user, ROLES_CORREDOR) && (
        <Route
          exact
          path="/corredor/liquidacion-garantia/"
          component={CorredorGarantiaLiquidacionListContainer}
        />
      )}
      {!externalUserHasRole(user, ROLES_CORREDOR) && (
        <Route
          exact
          path="/corredor/liquidacion-garantia/:liquidacionId"
          component={CorredorLiquidacionGarantiaDetalleContainer}
        />
      )}
      <Route
        exact
        path="/resumen"
        render={(props) => <ResumenContainer {...props} user={user} />}
      />
      <Route
        exact
        path="/operaciones/libros-venta"
        component={OperacionesLibrosVentaContainer}
      />
      <Route
        exact
        path="/operaciones/liquidaciones-credito"
        component={OperacionesLiquidacionCreditoContainer}
      />
      <Route render={() => <Redirect to={userHomeComponent} />} />
    </Switch>
  );
};

LoggedInRoutes.propTypes = {
  user: PropTypes.shape({
    has_access: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    userToken: state.login.userToken,
    user: state.login.user,
  };
};

export default withRouter(connect(mapStateToProps)(LoggedInRoutes));
